module.exports = __webpack_public_path__ + "static/img/invoice.b03c7a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/invoice.png
// module id = 7Iak
// module chunks = 24